import { PublicClientApplication } from '@azure/msal-browser';
import { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

interface MyRouterContext {
  queryClient: QueryClient;
  msalInstance: PublicClientApplication;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: function Main() {
    return <Outlet />;
  },
});
